import * as React from "react";
import type { SVGProps } from "react";
const SvgChefHat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.353 21.707A1 1 0 0 0 6.06 22h12a1 1 0 0 0 1-1v-6.47a5 5 0 0 0 2.78-5.87 5 5 0 0 0-2.34-3A5 5 0 0 0 16.65 5a5 5 0 0 0-4.59-3 5 5 0 0 0-4.58 3 5 5 0 0 0-5.33 3.8 5 5 0 0 0 .58 3.79 5 5 0 0 0 2.33 2V21a1 1 0 0 0 .293.707M17.06 16v-2.13a1 1 0 0 1 .74-1 3 3 0 0 0 1.591-4.73 3 3 0 0 0-.881-.77 3 3 0 0 0-2.28-.29 1 1 0 0 1-.78-.11 1.05 1.05 0 0 1-.46-.65A3 3 0 0 0 12.06 4a3 3 0 0 0-2.93 2.36 1 1 0 0 1-.47.65 1 1 0 0 1-.8.1h-.15a3 3 0 0 0-1.41 5.83 1 1 0 0 1 .76 1V16zm0 2h-10v2h10z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChefHat;
